import React from 'react';
export const loadingIcon = <img src='/public/loading.gif' width='360px'/>;